import { useQuery, useLazyQuery, gql } from "@apollo/client"
import * as Sentry from "@sentry/browser"

const LIBRARY_TEMPLATES_LIMIT = 10

const LIBRARY_TEMPLATE_FIELDS = `
  id
  name
  description
  categories { id name }
  steps {
    name
    responseType
    description
    uploads { id key fileName fileGroup fileSize }
  }
  repeat { 
    type
    frequency
    weekdays { 
      monday tuesday wednesday thursday friday saturday sunday 
    }
    months { 
      january february march april may june july august september october november december
    }
  }
  users { id fullName firstName lastName avatar { key } }
  groups { id name }
  author { id fullName firstName lastName avatar { key } }
  createdAt
  updatedAt
`

const LIBRARY_TEMPLATES_QUERY = gql`query LibraryTemplates ($category: ID!, $searchText: String, $offset: Int) {
  libraryTemplates(category: $category, searchText: $searchText, limit: ${LIBRARY_TEMPLATES_LIMIT}, offset: $offset) {
    items {
      ... on Process {
        __typename
        ${LIBRARY_TEMPLATE_FIELDS}
      }    
    }
    total
  } 
}`

const loadMore = (result) => async () => {
  try {
    await result.fetchMore({
      variables: {
        ...result.variables,
        offset: result.data.libraryTemplates.items.length,
        limit: LIBRARY_TEMPLATES_LIMIT,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev
        return {
          ...prev,
          libraryTemplates: {
            items: [...prev.libraryTemplates.items, ...fetchMoreResult.libraryTemplates.items],
            total: fetchMoreResult.libraryTemplates.total,
            __typename: prev.libraryTemplates.__typename,
          },
        }
      },
    })
  } catch (error) {
    Sentry.captureException(error)
  }
}

const useQueryLibraryTemplates = (options) => useQuery(LIBRARY_TEMPLATES_QUERY, options)

const useLazyQueryLibraryTemplates = () => {
  const [loadTemplates, result] = useLazyQuery(LIBRARY_TEMPLATES_QUERY, {
    variables: {
      offset: 0,
      limit: LIBRARY_TEMPLATES_LIMIT,
    },
    fetchPolicy: "cache-and-network",
  })

  return [
    loadTemplates,
    {
      ...result,
      loadMore: loadMore(result),
    },
  ]
}

export { useQueryLibraryTemplates, useLazyQueryLibraryTemplates, LIBRARY_TEMPLATE_FIELDS }
